import { defineComponent as g, useCssVars as k, useSlots as h, ref as y, computed as r, watch as b, nextTick as w, openBlock as t, createElementBlock as l, normalizeClass as C, mergeProps as V, toDisplayString as n, renderSlot as i, createTextVNode as z, createCommentVNode as B } from "vue";
import T from "../config.mjs";
import { calculateValue as _ } from "./IstProgress.mjs";
const $ = ["max", "value"], A = {
  key: 2,
  class: "progress-value"
}, I = /* @__PURE__ */ g({
  inheritAttrs: !1,
  __name: "IstProgress",
  props: {
    size: { default: "" },
    backgroundcolor: { default: "--ist-color-ist-700" },
    rounded: { type: Boolean, default: !0 },
    value: { default: void 0 },
    max: { default: 100 },
    showValue: { type: Boolean, default: !1 },
    format: { default: "raw" },
    precision: { default: 2 },
    keepTrailingZeroes: { type: Boolean, default: !1 },
    locale: { default: T.defaultLocale }
  },
  setup(c) {
    k((a) => ({
      "97041cae": p.value
    }));
    const d = h(), o = y(), e = c, v = r(() => e.value === void 0 || e.value === null), f = r(() => [
      e.size,
      {
        "is-more-than-half": e.value && e.value > e.max / 2
      }
    ]), u = r(() => _(e.value, e)), p = r(() => e.backgroundcolor.startsWith("--") ? `var(${e.backgroundcolor})` : e.backgroundcolor), s = r(() => d.bar == null), m = r(() => ({
      "is-not-native": !s.value,
      [e.size ?? ""]: typeof e.size == "string" && !s.value
    }));
    return b(v, function(a) {
      w(() => {
        o.value && (a ? o.value.removeAttribute("value") : o.value.setAttribute("value", e.value));
      });
    }), (a, N) => (t(), l("div", {
      class: C(["progress-wrapper", [m.value, { "is-squared": !a.rounded }]])
    }, [
      s.value ? (t(), l("progress", V({
        key: 0,
        ref_key: "progress",
        ref: o,
        class: ["progress", [f.value, { "is-squared": !a.rounded }]],
        max: a.max,
        value: a.value
      }, a.$attrs), n(u.value), 17, $)) : i(a.$slots, "bar", { key: 1 }),
      s.value && a.showValue ? (t(), l("p", A, [
        i(a.$slots, "default", {}, () => [
          z(n(u.value), 1)
        ])
      ])) : B("", !0)
    ], 2));
  }
});
export {
  I as default
};
